import React from 'react'
import BaseIcon from './BaseIcon'

const DownIcon = (props: any) => {
  return <BaseIcon img="/img/arrow-down.png" onClick={props.onClick} />
}

export default DownIcon
